<!-- 고객 입금 관리 -->
<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="board clear">
            <div v-if="viewType === 'claimList'" class="tab-list-wrap">
              <ul class="tab-list">
                <li :class="tab === 0 ? 'on' : ''" @click="changeTab(0)">사용 내역 조회</li>
                <!-- TODO <li :class="tab === 1 ? 'on' : ''" @click="changeTab(1)">처리 결과 조회</li> -->
              </ul>
              <div class="tab-slide">
                <div class="tab-slide-bg"></div>
                <div :class="tab === 0 ? 'tab-slide-on' : ''"></div>
                <div :class="tab === 1 ? 'tab-slide-on' : ''" :style="tab === 1 ? 'left:120px;' : ''"></div>
              </div>
            </div>

            <div class="viewer">
              <div v-if="viewType === 'claimList'" class="list">
                <SearchConditions
                  class="search-conditions"
                  searchType="refund"
                  :tab="tab"
                  :downloading="downloading"
                  @search="search"
                  @downloadResult="downloadResult"
                ></SearchConditions>

                <ClaimList
                  v-show="tab === 0"
                  class="claim-list"
                  searchType="refund"
                  :searchCondition="searchCondition"
                  :startTime="startTime"
                  :endTime="endTime"
                  :searchEvent="searchEvent"
                  @selectPay="selectPay"
                ></ClaimList>

                <ClaimResultList
                  v-show="tab === 1"
                  class="claim-list"
                  searchType="refund"
                  :searchCondition="searchCondition"
                  :startTime="startTime"
                  :endTime="endTime"
                  :searchEvent="searchEvent"
                  :downloadEvent="downloadEvent"
                  @downloaded="downloaded"
                ></ClaimResultList>
              </div>
              <div v-else-if="viewType === 'claimDetail'" class="detail">
                <ClaimDetail
                  ClaimDetail
                  class="claim-detail"
                  searchType="refund"
                  :uID="uID"
                  :selectedID="selectedID"
                  @refresh="refresh"
                ></ClaimDetail>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import SearchConditions from '@/components/claim/SearchConditions';
import ClaimList from '@/components/claim/ClaimList';
import ClaimResultList from '@/components/claim/ClaimResultList';
import ClaimDetail from '@/components/claim/ClaimDetail';

export default {
  components: {
    Toolbar,
    Navigation,
    SearchConditions,
    ClaimList,
    ClaimResultList,
    ClaimDetail,
  },
  data: () => ({
    tab: 0,
    menu: null,
    viewType: 'claimList',
    searchCondition: null,
    startTime: '',
    endTime: '',
    searchEvent: 0,
    selectedID: null,
    menuInfo: {
      mainTitle: 'Refund',
      mainName: '고객 입금 관리',
      subTitle: '',
      subName: '',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
    downloadEvent: 0,
    downloading: false,
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.uID = token.uID;
    this.menu = this.$route.name;
  },
  /*
  mounted() {
    this.searchEvent ^= 1;
  },
  */
  methods: {
    search(condition, startTime, endTime) {
      this.searchCondition = condition;
      this.startTime = startTime;
      this.endTime = endTime;
      this.searchEvent ^= 1;
    },
    selectPay(ID) {
      this.$router.push({ name: 'RefundDetail', query: { selectedID: ID } }).catch(() => {});

      this.selectedID = ID;
      this.viewType = 'claimDetail';
    },
    refresh() {
      this.selectedID = null;
      this.viewType = 'claimList';
      this.searchEvent ^= 1;
    },
    changeTab(tab) {
      this.tab = tab;
    },
    downloadResult(condition, startTime, endTime) { // TODO
      this.downloading = true;
      this.searchCondition = condition;
      this.startTime = startTime;
      this.endTime = endTime;
      this.downloadEvent ^= 1;
    },
    downloaded() {
      this.downloading = false;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/claim/Refund.vue